import { render, staticRenderFns } from "./ContractFilesUpdateHistory.vue?vue&type=template&id=22f0fdfe&scoped=true&"
import script from "./ContractFilesUpdateHistory.vue?vue&type=script&lang=ts&"
export * from "./ContractFilesUpdateHistory.vue?vue&type=script&lang=ts&"
import style0 from "./ContractFilesUpdateHistory.vue?vue&type=style&index=0&id=22f0fdfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f0fdfe",
  null
  
)

export default component.exports